"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montefiascone": {
    "760d4e5a": [{
      "hkey": "ec2af9fc",
      "slug": "le-mosse",
      "name": "Le Mosse",
      "primary": true,
      "skipSearch": false
    }],
    "carpine": [{
      "hkey": "ec2af9fc",
      "slug": "le-mosse",
      "name": "Le Mosse",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montefiascone"
    }],
    "214888c6": [{
      "hkey": "b16b1793",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cipollone": [{
      "hkey": "b16b1793",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "143f3a77": [{
      "hkey": "b16b1793",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "fiordini": [{
      "hkey": "b16b1793",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montefiascone"
    }],
    "18d409fe": [{
      "hkey": "ec2af9fc",
      "slug": "le-mosse",
      "name": "Le Mosse",
      "primary": true,
      "skipSearch": false
    }],
    "mosse": [{
      "hkey": "ec2af9fc",
      "slug": "le-mosse",
      "name": "Le Mosse",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a2814756": [{
      "hkey": "b16b1793",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "poggetto": [{
      "hkey": "b16b1793",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montefiascone"
    }],
    "033faf24": [{
      "hkey": "d8b01a57",
      "slug": "coste-pelucche",
      "name": "Coste-Pelucche",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-frusta": [{
      "hkey": "d8b01a57",
      "slug": "coste-pelucche",
      "name": "Coste-Pelucche",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montefiascone"
    }],
    "507d428f": [{
      "hkey": "0668d1d0",
      "slug": "montefiascone",
      "name": "Montefiascone",
      "primary": true,
      "skipSearch": false
    }],
    "stefanoni": [{
      "hkey": "0668d1d0",
      "slug": "montefiascone",
      "name": "Montefiascone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "572e25dc": [{
      "hkey": "b0a11f04",
      "slug": "cevoli-zepponami-pian-di-monetto",
      "name": "Cevoli-Zepponami-Pian di Monetto",
      "primary": true,
      "skipSearch": false
    }],
    "zepponami": [{
      "hkey": "b0a11f04",
      "slug": "cevoli-zepponami-pian-di-monetto",
      "name": "Cevoli-Zepponami-Pian di Monetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;